import fetch ,{postFrom} from "../utils/fetch";

// 缴费凭证查询条件
export function getConditions() {
  return fetch({
    method:'GET',
    url:'certificate/condition'
  })
}

// 获取缴费凭证列表
export function getList(params) {
  return fetch({
    method:'GET',
    url:'certificate/list',
    params
  })
}

// 作废缴费凭证
export function deleteCertificate(billNum,fCode) {
  return postFrom('certificate/invalid', {billNum:billNum,fCode:fCode})
}

// 缴费信息详情
export function getDetail(projectFid,billNum) {
  return fetch({
    method:'GET',
    url:'certificate/detail',
    params:{
      projectFid,
      billNum
    }
  })
}
